








































































































































import mixins from 'vue-typed-mixins';
import _ from 'lodash';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { mapActionsDvm } from '@/main/pages';
import { store } from '@/modules/servis/zakazka/store/edit';

import { SkupinaProfilSelect } from '../../components';
import JinyPrijemceSelect from '../../components/microcomponents/JinyPrijemceSelect.vue';
import LeasingSelect from '../../components/microcomponents/LeasingSelect.vue';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';
import SmluvniPartnerSelect from '../../components/microcomponents/SmluvniPartnerSelect.vue';
import SmluvniPartnerTypSelect from '../../components/microcomponents/SmluvniPartnerTypSelect.vue';
import SDA from '../../components/microcomponents/SDA.vue';
import MicroLakDruhSelect from '../../components/microcomponents/LakDruhSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';
import { EditMixin } from '../../mixins/editMixin';


type ValidationPodilRule = { validator: () => void, message: string };

export default mixins(PageModeMixin, EditMixin).extend({
	name: 'HlavniKarta',
	components: {
		MicroLakDruhSelect,
		SmluvniPartnerTypSelect,
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		SkupinaProfilSelect,
		LeasingSelect,
		SmluvniPartnerSelect,
		JinyPrijemceSelect,
		SlevaInputNumber,
		sda: SDA,
	},
	computed: {
		ddCustomerRevisitPrp() : boolean | null {
			return this.dmsSys.CustomerRevisitPrp && this.IsCustRevisit;
		},
		prevodMaxSuffix(): string {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
		isPodilZak(): number {
			return this.PodilMatZak || this.PodilSlzZak;
		},
		validationPodilSoucetMessage() {
			return this.LocalizeChyboveHlasky('SumSlz');
		},
		validatePodilMat(): ValidationPodilRule {
			const validator = () => {
				if (_.has(this.$refs, 'PodilMatGd')) {
					(this.$refs?.PodilMatGd as any).formItem.clearValidate();
					(this.$refs?.PodilMatInt as any).formItem.clearValidate();
					(this.$refs?.PodilMatZak as any).formItem.clearValidate();
				}
				return (this.PodilMatGd ?? 0) + (this.PodilMatInt ?? 0) + (this.PodilMatZak ?? 0) === 100;
			};
			return { validator, message: this.validationPodilSoucetMessage };
		},
		validatePodilSlz(): ValidationPodilRule {
			const validator = () => {
				if (_.has(this.$refs, 'PodilSlzGd')) {
					(this.$refs?.PodilSlzGd as any).formItem.clearValidate();
					(this.$refs?.PodilSlzInt as any).formItem.clearValidate();
					(this.$refs?.PodilSlzZak as any).formItem.clearValidate();
				}
				return (this.PodilSlzGd ?? 0) + (this.PodilSlzInt ?? 0) + (this.PodilSlzZak ?? 0) === 100;
			};
			return { validator, message: this.validationPodilSoucetMessage };
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		intPodilChange() {
			return this.zmenaIntPodil();
		},
	},
});
